import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { __API_URL__ } from "../SERVER_URL";

const fetchTrialLogs = async (userId) => {
  const token = localStorage.getItem("token");

  if (!userId) throw new Error("userId is required");

  const response = await axios.get(`${__API_URL__}/api/appiell/get_trial_logs/${userId}`, {
    headers: {
      Authorization: `Token ${token}`,
    },
  });

  return response.data;
};

const useGetTrialLogs = ({ userId, enabled = true }) => {
  return useQuery({
    queryKey: ["trial_logs", userId],
    queryFn: () => fetchTrialLogs(userId),
    enabled: enabled && Boolean(userId),
  });
};

export default useGetTrialLogs;
